import React from 'react';
import MessageForm, { FormData } from '../molecules/MessageForm';
import { useLetterStore } from '../../store/letterStore';
import { useNavigate } from 'react-router-dom';
import AIGenerateForm, {
  AIGenerateFormData,
} from '../molecules/AIGenerateForm';
import { useAiStore } from '@/store/aiStore';
import { chatWithAI } from '@/lib/openaiClient';
import { constraint, prompts } from '@/data/prompts';

const Message: React.FC = () => {
  const navigate = useNavigate();
  const { letterData, setLetterData } = useLetterStore();
  const { aiData, createAiData, setAiData } = useAiStore();

  console.log('aiData', aiData);

  const onSubmit = (data: FormData) => {
    const formData = {
      message: data.message,
    };

    setLetterData(formData);

    navigate('/edit');
  };

  const onSubmitAi = async (data: AIGenerateFormData) => {
    console.log('onSubmitAi', data);
    if (aiData) {
      setAiData(data);
    } else {
      createAiData(data);
    }

    const prompt =
      prompts.find(
        (prompt) =>
          prompt.style === data.style && prompt.subStyle === data.subStyle
      )?.prompt || '';
    if (!prompt) {
      window.alert('プロンプトが見つかりませんでした');
      return;
    }
    try {
      const response = await chatWithAI(
        prompt + '\n' + constraint,
        `「${data.objective}」について手紙を書こうと考えています。文章を作成してください。`
      );
      setLetterData({
        message: response,
      });
    } catch (error) {
      window.alert('エラーが発生しました');
    }
  };

  // letterDataがnullの場合は空のオブジェクトを渡す
  const defaultValues: FormData = letterData
    ? {
        message: letterData.message || '',
      }
    : {
        message: '',
      };

  const aiDefaultValues: AIGenerateFormData = aiData
    ? {
        objective: aiData.objective || '',
        style: aiData.style || '',
        subStyle: aiData.subStyle || '',
      }
    : {
        objective: '',
        style: '',
        subStyle: '',
      };

  return (
    <div>
      <div>
        <AIGenerateForm defaultValues={aiDefaultValues} onSubmit={onSubmitAi} />
      </div>
      <div className='u-mt60'>
        <MessageForm defaultValues={defaultValues} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default Message;
